import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import './plugins/element.js'
import './assets/css/global.css'
import previous from "@/components/previous";
import confenrence from "@/components/confenrence";
import choose from "@/components/choose";
import Header from "@/header/Header";
import VipRegister from "@/register/VipRegister";
import previous2 from "@/components/previous2";
import footer from "@/components/footer";
Vue.component('Header', Header)
Vue.component('choose', choose)
Vue.component('previous', previous)
Vue.component('previous2', previous2)
Vue.component('confenrence', confenrence)
Vue.component('VipRegister', VipRegister)
Vue.component('Footer', footer)
Vue.config.productionTip = false
Vue.prototype.$http = axios
//防止button连续点击
import preventReClick from '/src/button'
Vue.use(preventReClick)

//富文本编辑器
import VueUeditorWrap from 'vue-ueditor-wrap';
Vue.component('vue-ueditor-wrap', VueUeditorWrap);

//请求拦截器
axios.interceptors.request.use(config => {
  let id = window.vm.$route.query.id
  window.localStorage.setItem("id",id)
  //头部token验证
  config.headers.Authorization = 'Bearer '+window.localStorage.getItem(`token${id}`)
  // console.log(config)
  return config
})
//回应拦截器
axios.interceptors.response.use((config) => {
  if(config.status === 401){
    let id = localStorage.getItem("id")
    // window.localStorage.clear()
    // window.sessionStorage.clear()
    window.localStorage.setItem("id",id)
    window.vm.$store.commit("changeConfId",id)
    window.vm.$message.error('Please log in first')
    window.vm.$router.push('/login?id='+id)
    return false
  }else if(config.data.code === 401){
    let id = localStorage.getItem("id")
    // window.localStorage.clear()
    // window.sessionStorage.clear()
    window.localStorage.setItem("id",id)
    window.vm.$store.commit("changeConfId",id)
    window.vm.$message.error('Please log in first')
    window.vm.$router.push('/login?id='+id)
    return false
  }
  return config
})


window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
